import React, { useState } from "react";
import { api } from "../lib/api";
import { getStoredRef } from "../lib/referral";
import { toast } from "sonner";
import { X } from "lucide-react";

export default function ListSignupModal({ event, onClose }) {
  const [form, setForm] = useState({ name: "", email: "", people: 2, phone: "", referral_code: getStoredRef() });
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/lists/signup", {
        event_id: event.id,
        name: form.name,
        email: form.email,
        people: Number(form.people),
        phone: form.phone,
        referral_code: form.referral_code || undefined,
      });
      toast.success("Sei in lista! Ti aspettiamo in porta.");
      onClose();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Errore. Riprova.");
    } finally { setLoading(false); }
  };
  return (
    <div className="fixed inset-0 z-[100] bg-black/80 backdrop-blur-md flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-neutral-950 border border-neutral-800 w-full max-w-md p-8 relative" onClick={e=>e.stopPropagation()} data-testid="list-signup-modal">
        <button className="absolute top-4 right-4 text-neutral-500 hover:text-white" onClick={onClose} data-testid="list-signup-close" aria-label="Chiudi"><X/></button>
        <div className="label-mono text-neon mb-2">METTITI IN LISTA</div>
        <h3 className="font-display text-2xl mb-1">{event.title}</h3>
        <div className="font-mono text-xs text-neutral-500 tracking-widest mb-6">
          {new Date(event.date).toLocaleDateString("it-IT",{day:"2-digit",month:"short"})} · {event.venue}, {event.city}
        </div>
        <form onSubmit={submit} className="space-y-5">
          <div>
            <div className="label-mono mb-1">NOME</div>
            <input required value={form.name} onChange={e=>setForm({...form,name:e.target.value})} className="input-dark" data-testid="list-name"/>
          </div>
          <div>
            <div className="label-mono mb-1">EMAIL (per il promemoria della serata)</div>
            <input required type="email" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} className="input-dark" data-testid="list-email"/>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <div className="label-mono mb-1">PERSONE</div>
              <input required type="number" min="1" max="20" value={form.people} onChange={e=>setForm({...form,people:e.target.value})} className="input-dark" data-testid="list-people"/>
            </div>
            <div>
              <div className="label-mono mb-1">TELEFONO</div>
              <input value={form.phone} onChange={e=>setForm({...form,phone:e.target.value})} className="input-dark" data-testid="list-phone"/>
            </div>
          </div>
          <div>
            <div className="label-mono mb-1">CODICE REFERRAL (opz.)</div>
            <input value={form.referral_code} onChange={e=>setForm({...form,referral_code:e.target.value.toUpperCase()})} className="input-dark font-mono" data-testid="list-referral"/>
          </div>
          <button disabled={loading} className="btn-primary w-full" data-testid="list-submit">
            {loading ? "..." : "CONFERMA ENTRATA"}
          </button>
        </form>
      </div>
    </div>
  );
}
